import { Home, Bell, Settings, BarChart3, Menu, X } from "lucide-react";
import { NavLink } from "react-router-dom";
import { useContext, useState } from "react";
import { cn } from "../lib/utils";
import { Label } from "./ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { AuthContext } from "../hoc/AuthContext";
import variable from "../lib/variable";

const navigation = [
  {
    name: "Dashboard",
    href: "/services/notification/dashboard",
    icon: Home,
    access: "services/notification/campaigns",
  },
  {
    name: "Category bucket",
    href: "/services/notification/topics",
    icon: BarChart3,
    access: "services/notification/campaigns",
  },
  {
    name: "Notifications",
    href: "/services/notification/list",
    icon: Bell,
    access: "services/notification/campaigns",
  },
  {
    name: "Settings",
    href: "/services/notification/setting",
    icon: Settings,
    access: "services/notification/setting",
  },
];

export default function SidebarList() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const {
    setIsAuthenticated,
    setAuthUserData,
    authUserData,
    selectedDomain,
    setSelectedDomain,
  } = useContext(AuthContext);
  const setDomain = (value) => {
    const val = authUserData?.productslist?.find(
      (el) => el.domain_url == value
    );
    localStorage.setItem(variable.DEFAULT_DOMAIN, val.domain_url);
    setSelectedDomain(val);
  };
  return (
    <>
      {/* Mobile menu button */}
      <button
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        className="  lg:hidden fixed top-4 left-4 z-50 p-2 rounded-lg bg-card shadow-lg border border-border"
      >
        {mobileMenuOpen ? (
          <X className="h-6 w-6 text-foreground" />
        ) : (
          <Menu className="h-6 w-6 text-foreground" />
        )}
      </button>

      {/* Mobile backdrop */}
      {mobileMenuOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black/50 z-30"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={cn(
          "fixed lg:sticky top-0 left-0 z-40 h-screen w-64 bg-card border-r border-border transition-transform duration-300",
          mobileMenuOpen
            ? "translate-x-0"
            : "-translate-x-full lg:translate-x-0"
        )}
      >
        <div className="flex h-full flex-col bg-white">
          {/* Logo */}
          <div className="flex h-16 items-center border-b border-border px-6">
            <h1 className="text-xl font-bold text-primary">
              Notification Admin
            </h1>
          </div>

          {/* Navigation */}
          <nav className="flex-1 space-y-1 p-4">
            {selectedDomain?.accessList?.length>0&&navigation.map((item) => {
           
              if (
                selectedDomain?.accessList?.some(
                  (el) => el.route_url == item.access
                )
              )
                return (
                  <NavLink
                    key={item.name}
                    to={item.href}
                    onClick={() => setMobileMenuOpen(false)}
                    className={({ isActive }) =>
                      cn(
                        "flex items-center gap-3 rounded-lg px-4 py-3 text-sm font-medium transition-colors",
                        isActive
                          ? "bg-accent text-accent-foreground"
                          : "text-muted-foreground hover:bg-secondary hover:text-foreground"
                      )
                    }
                  >
                    <item.icon className="h-5 w-5" />
                    {item.name}
                  </NavLink>
                );
            })}
            <NavLink className="space-y-2">
              <Label>Domain </Label>
              <div className="flex gap-2">
                <Select
                  value={selectedDomain.domain_url}
                  onValueChange={setDomain}
                >
                  <SelectTrigger className="flex-1">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    {authUserData?.productslist.map((el) => {
                      return (
                        <SelectItem key={el.domain_url} value={el.domain_url}>
                          {el.product_name}
                        </SelectItem>
                      );
                    })}
                  </SelectContent>
                </Select>
              </div>
            </NavLink>
          </nav>

          {/* Footer */}
          {/* <div className="border-t border-border p-4">
            <div className="flex items-center gap-3 px-4 py-3">
              <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center">
                <span className="text-sm font-semibold text-primary">AD</span>
              </div>
              <div className="flex-1">
                <p className="text-sm font-medium text-foreground">Admin User</p>
                <p className="text-xs text-muted-foreground">admin@epaper.com</p>
              </div>
            </div>
          </div> */}
        </div>
      </aside>
    </>
  );
}
